var _path, _path2, _g, _g2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDefault(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1355_263)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1355_263",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 2,
    width: 48,
    height: 44
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 34.4286C1 34.4286 14.7209 45.1001 25 45.1001C35.2791 45.1001 49 34.4286 49 34.4286V2.10011H1V34.4286Z",
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1355_263)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1355_263",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 21,
    width: 32,
    height: 25
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4319 44.6222C22.2569 41.355 9.7417 33.8014 9.7417 30.1948C9.7417 25.2544 16.573 21.2495 25 21.2495C33.4269 21.2495 40.2583 25.2544 40.2583 30.1948C40.2583 33.8014 28.0859 40.3327 26.5681 44.6222C25.8103 45.264 24.1895 45.2639 23.4319 44.6222Z",
    fill: "url(#paint0_linear_1355_263)",
    fillOpacity: 0.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1355_263)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.9946,
    cy: 45.1228,
    rx: 3.73846,
    ry: 1.09371,
    fill: "url(#paint1_radial_1355_263)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1355_263)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.4065 44.9432C10.6929 33.8442 8.33301 32.7051 8.33301 28.6261C8.33301 23.0387 15.8546 18.5093 25.133 18.5093C34.4114 18.5093 41.933 23.0387 41.933 28.6261C41.933 32.7051 39.5731 33.8442 26.8596 44.9432C26.0252 45.669 24.2407 45.6689 23.4065 44.9432Z",
    fill: "url(#paint2_linear_1355_263)"
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter1_ddddd_1355_263)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.4584 44.193C12.107 27.7368 10 26.0479 10 20C10 11.7157 16.7157 5 25 5C33.2843 5 40 11.7157 40 20C40 26.0479 37.893 27.7368 26.5416 44.193C25.7966 45.2691 24.2033 45.269 23.4584 44.193ZM25 26.25C28.4518 26.25 31.25 23.4518 31.25 20C31.25 16.5482 28.4518 13.75 25 13.75C21.5482 13.75 18.75 16.5482 18.75 20C18.75 23.4518 21.5482 26.25 25 26.25Z",
    fill: "url(#paint3_linear_1355_263)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4584 44.193C12.107 27.7368 10 26.0479 10 20C10 11.7157 16.7157 5 25 5C33.2843 5 40 11.7157 40 20C40 26.0479 37.893 27.7368 26.5416 44.193C25.7966 45.2691 24.2033 45.269 23.4584 44.193ZM25 26.25C28.4518 26.25 31.25 23.4518 31.25 20C31.25 16.5482 28.4518 13.75 25 13.75C21.5482 13.75 18.75 16.5482 18.75 20C18.75 23.4518 21.5482 26.25 25 26.25Z",
    fill: "url(#paint4_linear_1355_263)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1355_263",
    x: 2.33301,
    y: 12.5093,
    width: 45.6,
    height: 38.9783,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_1355_263"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ddddd_1355_263",
    x: 6,
    y: -3,
    width: 38,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1355_263"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1355_263",
    result: "effect2_dropShadow_1355_263"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_1355_263",
    result: "effect3_dropShadow_1355_263"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_1355_263",
    result: "effect4_dropShadow_1355_263"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_dropShadow_1355_263",
    result: "effect5_dropShadow_1355_263"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect5_dropShadow_1355_263",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1355_263",
    x1: 25,
    y1: 45.1035,
    x2: 25,
    y2: 21.2495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2372,
    stopColor: "#25303D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2F2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1355_263",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.9946 45.1228) rotate(90) scale(1.09371 3.73846)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0809412
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747647,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1355_263",
    x1: 25.133,
    y1: 45.4875,
    x2: 25.133,
    y2: 18.5093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2372
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2F2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1355_263",
    x1: 10,
    y1: 5,
    x2: 48.4,
    y2: 33.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04BEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4481EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1355_263",
    x1: 10,
    y1: 5,
    x2: 48.4,
    y2: 33.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04BEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4481EB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1355_263"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefault);
export default __webpack_public_path__ + "static/media/default.0fbb8cb0f954b3ee8db925a3c0b43052.svg";
export { ForwardRef as ReactComponent };